module.exports = __webpack_public_path__ + "static/media/invalid.3b73ba28.mp3";